import React from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { Loader } from 'rsuite';
import styled from 'styled-components';
import * as viewer from './property-details-pdf-view-styles';

const PrintablePage = styled(Page)`
  display: inherit;
`;

/**
 * Creates Page objects using web worker under the hood
 * https://www.npmjs.com/package/react-pdf
 *
 * For each page that Document pass via the onDocumentLoad function
 * we need to have a Page object to represent that page in the UI.
 *
 * What is nice is that once the PDFs are rendered, we can use the Objects
 * to print nicely using the react-to-print lib
 *
 * @param {*} props
 * @returns Pages to display
 */
function Pages({ numPages, loading, currentPage }) {
  return Array(numPages)
    .fill()
    .map((_, i) => (
      <PrintablePage
        key={i}
        loading={loading}
        pageNumber={i + 1}
        renderAnnotationLayer={false}
        show={currentPage ? i + 1 === currentPage : true}
      />
    ));
}

// Loader displayed when the PDF pages are loading
function ViewerLoader() {
  return (
    <viewer.LoaderWrapper>
      <Loader size="md" />
    </viewer.LoaderWrapper>
  );
}

/**
 * Viewer portion of the PDF Viewer Modal. Responsible for rendering the PDF as
 * html canvas using react-pdf lib. Size changes for the modal occur here. We
 * use viewport height to account for different screen sizes. React-to-print
 * is also defined here. Once triggered, it starts the print preview with
 * content from the viewer component
 *
 * @param {*} props
 * @returns Viewer portion of modal
 */
function Viewer(props) {
  const {
    numPages,
    pdfFilePath,
    printContentRef,
    printMode,
    onDocumentLoadSuccess,
    currentPage,
  } = props;

  return (
    <viewer.PrintWrapper printMode={printMode}>
      <viewer.ViewerWrapper
        className="print-content"
        ref={printContentRef}
        printMode={printMode}
      >
        <Document
          file={pdfFilePath}
          loading={<ViewerLoader />}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          <Pages
            loading={<div></div>}
            numPages={numPages}
            currentPage={currentPage}
          />
        </Document>
      </viewer.ViewerWrapper>
    </viewer.PrintWrapper>
  );
}

export default Viewer;
